import {
  ClientFeedback,
  SubmitFeedbackPayload,
  FeedbackAnalytics,
} from "@shared/types/FeedbackDto";
import { ApiService } from "./ApiService";

export class FeedbackService {
  constructor(private readonly apiService: ApiService) {}

  async getMyFeedback(): Promise<ClientFeedback[]> {
    return this.apiService.request<ClientFeedback[]>("/feedback/client/my", {
      method: "GET",
      requireAuth: true,
    });
  }

  async submitFeedback(
    payload: SubmitFeedbackPayload,
  ): Promise<ClientFeedback> {
    return this.apiService.request<ClientFeedback>("/feedback/client", {
      method: "POST",
      body: JSON.stringify(payload),
      requireAuth: true,
    });
  }

  async updateFeedback(
    feedbackId: string,
    payload: Partial<SubmitFeedbackPayload>,
  ): Promise<{ success: boolean; feedback: ClientFeedback | null }> {
    return this.apiService.request<{
      success: boolean;
      feedback: ClientFeedback | null;
    }>(`/feedback/client/${feedbackId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
      requireAuth: true,
    });
  }

  async getFeedbackById(feedbackId: string): Promise<ClientFeedback | null> {
    return this.apiService.request<ClientFeedback | null>(
      `/feedback/client/${feedbackId}`,
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async getPendingPrompts(): Promise<{ hasPending: boolean; prompts: any[] }> {
    return this.apiService.request<{ hasPending: boolean; prompts: any[] }>(
      "/feedback/pending-prompts",
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async getAnalytics(): Promise<FeedbackAnalytics> {
    return this.apiService.request<FeedbackAnalytics>("/feedback/analytics", {
      method: "GET",
      requireAuth: true,
    });
  }
}
